module.exports = __webpack_public_path__ + "img/client3.96e3fba6.png";